import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {KeyAccountEditComponent} from '../../components/DomainDataEdit/KeyAccountEdit.component';

//base
import { BaseDomainDataGridComponent }         from '../../baseclasses/BaseDomainDataGrid';

@Component({
  selector: 'my-keyaccount-grid',
  templateUrl: './KeyAccountGrid.component.html'
})
export class KeyAccountGridComponent extends BaseDomainDataGridComponent {

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(KeyAccountEditComponent) recordEditComponent: KeyAccountEditComponent;

    userInfo: ent.UserInfo;
    records: ent.KeyAccount[];
    selectedRecords: ent.KeyAccount[] = [];
    editedRecord: ent.KeyAccount;
    cols: any[];

    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService,
         private router: Router) 
    {
        super();
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
        this.editedRecord = new ent.KeyAccount();
        this.loadColumns();
        this.onSearchClick(null);

        this.recordEditComponent.subtradeChannelDropdownComponent.load();
        this.recordEditComponent.tradeGroupDropdownComponent.load();
        this.recordEditComponent.tradeNameDropdownComponent.load();
        this.recordEditComponent.managedByDropdownComponent.load();
        this.recordEditComponent.globalCustomerDropdownComponent.load();
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'Code', header: 'Code' },
            { field: 'Name', header: 'Name' },
            { field: 'PrimaryFranchiseGroup', header: 'Primary Franchise Group' },
            { field: 'SubtradeChannel.Name', header: 'Subtrade Channel' },
            { field: 'TradeGroup.Name', header: 'Secondary Group' },
            { field: 'TradeName.Name', header: 'Trade Name' },
            { field: 'OverarchingProgramsGroup', header: 'Overarching Programs Group' },
            { field: 'SecondaryFranchiseAgreementsGroup', header: 'Secondary Franchise Agreements Group' },
            { field: 'OnOffPromotionsGroup', header: 'On/Off Promotions Group' },
            { field: 'ManagedBy.Name', header: 'Managed By' },
            { field: 'GlobalCustomer.Name', header: 'Global Customer' },
            { field: 'Inactive', header: 'Inactive' },
        ];
    }

    onSearchClick(event: any){
        var filter: filters.KeyAccountFilter = {IncludeInactive: true};
        this.domainDataService.getKeyAccounts(filter).subscribe(x=>{this.records = x});
    }

    onAddClick(event: any){
        this.editedRecord = new ent.KeyAccount();
        this.recordEditComponent.displayDialog = true;
    }
    
    onEditClick(event: any, keyAccount: ent.KeyAccount){
        this.editedRecord = keyAccount;
        this.recordEditComponent.subtradeChannelDropdownComponent.value = keyAccount.DefaultSubtradeChannelID;
        this.recordEditComponent.tradeGroupDropdownComponent.value = keyAccount.DefaultTradeGroupID;
        this.recordEditComponent.tradeNameDropdownComponent.value = keyAccount.DefaultTradeNameID;
        this.recordEditComponent.managedByDropdownComponent.value = keyAccount.ManagedByID;
        this.recordEditComponent.globalCustomerDropdownComponent.value = keyAccount.GlobalCustomerID;
        this.recordEditComponent.displayDialog = true;
    }

    onRecordEditOK(){
        var request: ent.SaveKeyAccountRequest = {KeyAccount: this.editedRecord, SavedByEmployee: this.userInfo.Employee};
        this.domainDataService.saveKeyAccount(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }
}